<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    content-class="sc-modal sc-modal--md"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box" role="button" aria-label="Visualizar câmera" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" @click="handlePreview">
        <v-icon>mdi-play</v-icon>
      </div>
        </template>
        <span>Visualizar câmera</span>
      </v-tooltip>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card" :key="cameraData.id">
      <v-btn icon class="sc-modal__close" @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header sc-modal__header--divided">
        <v-icon color="primary" class="mr-3">mdi-video-outline</v-icon>
        <div>
          <span class="sc-modal__title">{{ cameraData.nome || 'Preview' }}</span>
        </div>
      </div>

      <!-- Video -->
      <div class="preview-body">
        <HlsVideoPlayer :src="cameraData.streaming_url" :id="cameraData.id" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import HlsVideoPlayer from "@/components/HlsVideoPlayer.vue";

export default {
  props: {
    cameraData: Object,
  },
  components: { HlsVideoPlayer },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    handlePreview() {
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-body {
  padding: 0 24px 24px;
}
</style>
